"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
function useLazyKVMap(data, childrenColumnName, getRowKey) {
    var mapCacheRef = React.useRef({});
    function getRecordByKey(key) {
        if (!mapCacheRef.current ||
            mapCacheRef.current.data !== data ||
            mapCacheRef.current.childrenColumnName !== childrenColumnName ||
            mapCacheRef.current.getRowKey !== getRowKey) {
            var kvMap_1 = new Map();
            var dig_1 = function (records) {
                records.forEach(function (record, index) {
                    var rowKey = getRowKey(record, index);
                    kvMap_1.set(rowKey, record);
                    if (record && typeof record === 'object' && childrenColumnName in record) {
                        dig_1(record[childrenColumnName] || []);
                    }
                });
            };
            dig_1(data);
            mapCacheRef.current = {
                data: data,
                childrenColumnName: childrenColumnName,
                kvMap: kvMap_1,
                getRowKey: getRowKey,
            };
        }
        return mapCacheRef.current.kvMap.get(key);
    }
    return [getRecordByKey];
}
exports.default = useLazyKVMap;
//# sourceMappingURL=useLazyKVMap.js.map